export default __webpack_public_path__ + "static/media/abstract02.1d8d5946.webp";